var include_top_floating_bnr = `
<div class="top_floating">
		<button id="js-top_floating-close" class="top_floating-close"><img src="/material/img/common/icon/icon_close.png" alt="閉じる"></button>
		<div class="top_floating--wrap">
			<div class="top_floating--contents">
				<div class="top_floating--item">
					<a href="https://www.7card.co.jp/lp/plus/nnchp12.html" class="Nanaco_Lead7cardLink CvContentsArea01" target="_blank">
						<img src="/material/img/common/bnr/bnr_float_sevenplus.png" class="top_floating--bnr pc-only" alt="セブンカード・プラス年会費永年無料 4月1日～5月31日 新規入会・条件達成で最大6,600nanacoポイント">
						<img src="/material/img/common/bnr/bnr_float_sevenplus_sp.png" class="top_floating--bnr sp-only" alt="セブンカード・プラス年会費永年無料 4月1日～5月31日 新規入会・条件達成で最大6,600nanacoポイント">
					</a>
				</div>
			</div>
			<div class="top_floating--contents">
				<div class="top_floating--item">
					<a href="/introduction/#applepay" class="Nanaco_Lead7cardLink CvContentsArea01">
						<img src="/material/img/common/bnr/bnr_float_right.png" class="top_floating--bnr lazyload js-lazyload pc-only" alt="nanacoとスマホが1つに♪ nanacoアプリの詳細はこちら">
					</a>

					<a href="https://apps.apple.com/jp/app/nanaco/id1540014396" data-href-type="nanaco_appstore" target="_blank" class="sp-only appstore iphone_link"><img src="/material/img/common/bnr/bnr_float_right_app.png" class="top_floating--bnr lazyload js-lazyload iphone_link_ban_2" alt="nanacoとiPhoneが1つに"></a>
					<a href="https://play.google.com/store/apps/details?id=jp.nanaco.android&hl=ja" data-href-type="nanaco_playstore" target="_blank" class="sp-only android_img and_link"><img src="/material/img/common/bnr/bnr_float_right_android.png" class="top_floating--bnr lazyload js-lazyload and_link_ban" alt="nanacoとスマホが1つに"></a>
				</div>
			</div>
		</div>
</div>
`;
